<template>
    <div class="number-roller">
        <span v-if="prefix" class="prefix" :style="{'color':color}">{{ prefix }}</span>
        <span class="number" :style="{'color':color}">{{ displayNumber }}</span>
        <span v-if="suffix" class="suffix" :style="{'color':color}">{{ suffix }}</span>
    </div>
</template>

<script>
export default {
    name: 'NumberRoller',
    props: {
        // 目标数值
        value: {
            type: [Number, String],
            required: true,
            default: 0
        },
        color:{
            type: String,
            default: '#000'
        },
        // 动画持续时间（毫秒）
        duration: {
            type: Number,
            default: 2000
        },
        // 小数位数
        decimals: {
            type: Number,
            default: 0
        },
        fractionDigits:{
            type: Number,
            default: 2
        },
        // 数字前缀
        prefix: {
            type: String,
            default: ''
        },
        // 数字后缀
        suffix: {
            type: String,
            default: ''
        },
        // 动画延迟启动时间（毫秒）
        delay: {
            type: Number,
            default: 0
        },
        iSNumberFormat:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            startValue: 0,
            currentValue: 0,
            targetValue: 0,
            startTime: null,
            animationId: null
        }
    },
    computed: {
        // 格式化当前显示的数字
        displayNumber() {
            let fractionDigits=this.fractionDigits
            // // if(fractionDigits!=2){
            // //     let dataNum=  this.currentValue.toFixed(this.decimals)/;
            // // }
            // let dataStrLength=(this.currentValue+'').length
            // if(dataStrLength){

            // }else{
            //     fractionDigits=2
            // }
            let dataNum=  this.currentValue.toFixed(fractionDigits)
            return this.iSNumberFormat? this.formatCurrency(dataNum):dataNum
        }
    },
    watch: {
        // 监听 value 变化，重新开始动画
        value: {
            handler(newVal) {
                this.startAnimation(newVal);
            },
            immediate: true
        }
    },
    beforeDestroy() {
        // 组件销毁前取消动画，防止内存泄漏
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
    },
    methods: {
        formatCurrency(amount) {
            return new Intl.NumberFormat('zh-CN', {
                style: 'currency',
                currency: 'CNY',
                currencyDisplay: "code",
                minimumFractionDigits:2
            }).format(amount).replace('CNY','');
        },
        // 开始数字滚动动画
        startAnimation(target) {
            // 清除之前的动画
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
            }

            // 转换目标值为数字类型
            this.targetValue = parseFloat(target);
            this.startValue = this.currentValue;

            // 如果没有变化则直接返回
            if (this.startValue === this.targetValue) {
                this.currentValue = this.targetValue;
                return;
            }

            // 设置延迟启动
            setTimeout(() => {
                this.startTime = null;
                this.animationId = requestAnimationFrame(this.animateNumber);
            }, this.delay);
        },

        // 动画循环函数
        animateNumber(timestamp) {
            if (!this.startTime) this.startTime = timestamp;
            const progress = Math.min((timestamp - this.startTime) / this.duration, 1);

            // 使用缓动函数使动画更加自然
            const easeOutQuad = progress * (2 - progress);

            // 计算当前值
            this.currentValue = this.startValue + (this.targetValue - this.startValue) * easeOutQuad;

            // 继续动画直到完成
            if (progress < 1) {
                this.animationId = requestAnimationFrame(this.animateNumber);
            } else {
                // 确保最终值的精度
                this.currentValue = this.targetValue;
            }
        }
    }
}
</script>

<style scoped>
.number-roller {
    display: inline-flex;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: #333;
}

.prefix,
.suffix {
    margin: 0 4px;
}
</style>